import ServicePageTemplate from '../../components/sections/ServicePageTemplate';
import { SERVICE_PAGES } from '../../config/servicePagesData';

export default function MVPDevelopmentPage() {
  return <ServicePageTemplate service={SERVICE_PAGES.mvpDevelopment} />;
}
